import { SalonAnalysis } from './salon-analysis'

/**
 * Orange Salon Analysis - wrapper component using shared SalonAnalysis
 */
const OrangeSalonAnalysis = () => {
  return <SalonAnalysis operator="orange" />
}

export default OrangeSalonAnalysis
